// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const pieChartPlaceholder = "PieChartPlaceholder__pieChartPlaceholder__7sR-Q";
export const label = "PieChartPlaceholder__label__JC401 font-faces__sansSemibold__K6NQF font-faces__sans__uCf65";